import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Auth from '@/modules/Auth/Auth';
import { inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'SignoutButton',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const auth = inject('auth') as Auth

function signOut() {
  auth.SignOut().then(() => {
        router.push({
        path: "/login",
        query: { redirect: route.path }
        })
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "px-2 py-1 md:px-4 md:py-2 border rounded-full border-fau-blue-bright text-fau-blue-bright text-sm",
    onClick: signOut
  }, "Sign Out"))
}
}

})